import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "./data/content";
import { useGoToSection } from "../lib/useGo";
import Logo from "./Logo";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const go = useGoToSection();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 32);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-ink/85 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <a href="/" aria-label="Agency HQ home">
          <Logo />
        </a>

        <div className="hidden xl:flex items-center gap-6">
          {NAV_LINKS.map((l) => (
            <a
              key={l.id}
              href={`/#${l.id}`}
              onClick={go(l.id, "nav")}
              data-testid={`nav-link-${l.id}`}
              className="text-[13px] font-medium text-slate-300 transition-colors hover:text-white"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <a
            href="/#contact"
            onClick={go("contact", "nav")}
            data-testid="nav-cta-book-call-btn"
            className="hidden sm:inline-flex items-center rounded-full bg-gradient-to-r from-amber-500 to-amber-600 px-5 py-2.5 text-[13px] font-semibold text-slate-950 shadow-lg shadow-amber-500/20 transition-transform duration-200 hover:from-amber-600 hover:to-amber-700 active:scale-95"
          >
            Confidential Conversation
          </a>
          <button
            className="xl:hidden inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/10 text-white"
            onClick={() => setOpen(!open)}
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            data-testid="nav-mobile-toggle"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </nav>

      {open && (
        <div className="xl:hidden bg-ink/95 backdrop-blur-xl border-b border-white/10">
          <div className="px-6 py-6 flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <a
                key={l.id}
                href={`/#${l.id}`}
                onClick={(e) => {
                  go(l.id, "nav-mobile")(e);
                  setOpen(false);
                }}
                className="py-3 border-b border-white/5 font-display text-lg font-semibold text-slate-200 hover:text-white"
              >
                {l.label}
              </a>
            ))}
            <a
              href="/#contact"
              onClick={(e) => {
                go("contact", "nav-mobile")(e);
                setOpen(false);
              }}
              className="mt-4 inline-flex items-center justify-center rounded-full bg-gradient-to-r from-amber-500 to-amber-600 px-5 py-3 text-sm font-semibold text-slate-950"
            >
              Confidential Conversation
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Nav;
